<template>
	<div>
		<div class="title-container">
			<div class="title">Activity Log</div>
		</div>
		<div class="table-scroll-wrapper">
			<div class="table list">
				<div class="row" v-if="filtered.length === 0">
					<div class="cell align-center">There are no log entries yet.</div>
				</div>
				<div v-if="filtered.length > 0" class="row">
					<div class="cell">Actions</div>
					<div class="cell">User</div>
					<div class="cell">Module</div>
					<div class="cell">Time</div>
					<div class="cell">Interaction</div>
				</div>
				<div v-for="logEntry in filtered" :key="`logEntry-${ logEntry.id }`" class="row">
					<div class="cell buttons">
						<router-link v-if="$root.isSuperAdmin" :to="`/activity-log/${ logEntry.id }/details`" class="button"><div class="hover-title">JSON</div><span class="fab fa-js"></span></router-link>
						<router-link v-if="canViewActivity(logEntry)" :to="`/module/${logEntry.module.slug}/${logEntry.module_row_id}/edit`" class="button"><div class="hover-title">View</div><span class="fa fa-chevron-right"></span></router-link>
					</div>
					<div class="cell">{{ logEntry.user && logEntry.user.name || 'Unknown' }}</div>
					<div class="cell accent">{{ logEntry.module && logEntry.module.name || 'Unknown' }}</div>
					<div class="cell accent"><date :date="logEntry.created_at"></date></div>
					<div class="cell"><span :class="`tag ${ logEntry.type }`">{{ logEntry.interaction }}</span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import canViewActivity from '@/utils/can-view-activity';

export default {

	name: 'ActivityLogOverviewPage',

	async asyncData({ app }) {
		const { data } = await app.$api.get('/activity-log');

		return {
			activity: data,
		};
	},

	data() {
		return {
			activity: [],
			canViewActivity: canViewActivity,
		};
	},

	computed: {

		filtered() {
			return this.activity;
		},

	},

};

</script>
